export interface PagingResponseModel {
    totalRecords: number;
    pageNumber: number;
    pageSize: number;
  }

  export interface PagedResult<T> {
    items: T[];
    paging: PagingResponseModel;
  }